// Module-level mirror of the "acting as" shared member, so the (non-React) axios
// interceptor can read it without prop-drilling. The ActiveMemberContext is the
// source of truth and keeps this in sync. `null` means "act as yourself".
//
// We persist the shared user's household alongside their id: while acting as a
// shared user the app is scoped to that single household (they belong to exactly
// one), so the household switcher and calendar don't span the primary's others.

const STORAGE_KEY = 'chortle.activeMember';

export interface ActiveMember {
  id: string;
  householdId: string;
}

function load(): ActiveMember | null {
  if (typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as ActiveMember) : null;
  } catch {
    return null;
  }
}

let active: ActiveMember | null = load();

export function getActiveMember(): ActiveMember | null {
  return active;
}

export function getActiveMemberId(): string | null {
  return active?.id ?? null;
}

export function setActiveMember(member: ActiveMember | null): void {
  active = member;
  try {
    if (member) localStorage.setItem(STORAGE_KEY, JSON.stringify(member));
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage unavailable (private mode etc.) — in-memory value still works.
  }
}
